import { Typography } from '@material-ui/core';
import React from 'react';
import './Footer.css'
const Footer = () => {
    return (
        <div className="footer_wrap">
           <div className="footer_left">
                <Typography className="footer_name">
                Design and Developed by <a href="https://www.facebook.com/Exceptional.jim404" target="_blank">JIM@</a>
                </Typography>
           </div>
           <div className="footer_right">
                <Typography className="footer_copy">
                 <a href="https://www.facebook.com/Exceptional.jim404" target="_blank">Copyright 2020-2021 by Refsnes Data. All Rights Reserved.</a>
                </Typography>
           </div>
        </div>
    );
};

export default Footer;